'use strict';

/* globals config */

require([
	config.relative_path + '/plugins/nodebb-plugin-ideas-board/static/vendor/vue.js',
	'coverPhoto',
	'pictureCropper',
], function (Vue, coverPhoto, pictureCropper) {
	var internals = {};

	Vue.component('image-note', {
		props: ['note', 'saveNote'],
		data: function () {
			return {
				hasImage: typeof this.note.content.thumbUrl !== 'undefined',
			};
		},
		mounted: function () {
			if (!this.note.content) {
				this.note.content = {
					thumbUrl: '',
					imageUrl: '',
				};
			}
		},
		watch: {
			'note.noteId': function () {
				this.selectImage();
			},
		},
		methods: {
			selectImage: function () {
				var _this = this;
				internals.openSelectImage(_this.note.noteId, function (onSuccess) {
					_this.note.content.thumbUrl = onSuccess.thumb + '?' + Date.now();
					_this.note.content.imageUrl = onSuccess.image + '?' + Date.now();
					_this.hasImage = true;

					_this.saveFilePermissions(onSuccess.thumb);
					_this.saveFilePermissions(onSuccess.image);

					_this.saveNote();
				});
			},
		},
		template: '<div>' +
			'<a :href="note.content.imageUrl" target="_blank"><img v-if="note.content.thumbUrl" :src="note.content.thumbUrl" style="width: 100%" alt="image" /></a>' +
			'<button v-if="!hasImage" class="btn btn-primary waves-effect select-file" v-on:click="selectImage()">' +
			'<i class="fa fa-picture-o" aria-hidden="true"></i>' +
			'Select Image' +
			'</button>' +
			'</div>',
	});

	internals.openSelectImage = function (noteId, onSuccess) {
		pictureCropper.show({
			title: '[[ideas-board:select-image]]',
			socketMethod: 'plugins.ideasBoard.uploadPicture',
			aspectRatio: NaN,
			allowSkippingCrop: true,
			restrictImageDimension: false,
			paramName: 'noteId',
			paramValue: noteId,
		}, function (imageUrlOnServer) {
			onSuccess({
				thumb: imageUrlOnServer,
				image: imageUrlOnServer.replace('___thumb___', ''),
			});
		});
	};
});

